import { ColumnDef, createColumnHelper } from "@tanstack/react-table";
import { Box, IconButton, Text } from "@chakra-ui/react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ActorsElementT } from "shared/api/types/services";
import CutText from "shared/components/CutText";
import { PathsE } from "shared/routes";
import CopyButton from "shared/components/CopyButton";
import useGetColors from "shared/hooks/useGetColors";
import MuiIcon from "../../../../components/MuiIcon";
import Link from "../../../components/Link";

export const useGetGetBreadcrumbs = () => {
  const { t } = useTranslation();
  return [
    {
      path: PathsE.HOME,
      text: t('general.home'),
    },
  ];
}

interface Params {
  serviceId: string,
}

export const useGetColumns = ({ serviceId }: Params) => {
  const { t } = useTranslation();
  const columnHelper = createColumnHelper<ActorsElementT>();
  const { blue500 } = useGetColors();

  return useMemo(
    () => [
      columnHelper.accessor('id', {
        header: t('services.table.id'),
        id: 'id',
        cell: ({ getValue }) => (
          <CutText fontWeight="700">
            {getValue()}
          </CutText>
        ),
        meta: {
          isSorting: false,
          styles: {
            sizes: {
              width: '50px',
              maxW: '50px',
            }
          }
        }
      }),
      columnHelper.accessor('phone', {
        cell: ({ getValue }) => (
          <Box>
            {getValue()}
            <CopyButton text={getValue()} ml="8px" />
          </Box>
        ),
        header: t('services.table.phone'),
        id: 'phone',
      }),
      columnHelper.accessor('name', {
        header: t('Name'),
        id: 'name',
      }),
      // columnHelper.accessor('sex', {
      //   header: t('services.table.sex'),
      //   id: 'sex',
      // }),
      columnHelper.accessor('bio', {
        header: t('services.table.bio'),
        id: 'bio',
      }),
      columnHelper.accessor('nick', {
        header: t('services.table.nick'),
        id: 'nick',
      }),
      // columnHelper.accessor('description', {
      //   header: t('services.table.description'),
      //   id: 'description',
      // }),
      columnHelper.accessor('prompt', {
        header: t('services.table.description'),
        id: 'prompt',
        cell: ({ getValue }) => (
          <Text dangerouslySetInnerHTML={{ __html: getValue() }} />
        ),
        meta: {
          styles: {
            sizes: {
              width: '100px',
              maxW: '100px',
            }
          }
        }
      }),
      // columnHelper.accessor('createdAt', {
      //   header: t('services.table.createdAt'),
      //   id: 'createdAt',
      //   cell: ({ getValue }) => formatDateToHuman(getValue(), false),
      //   meta: {
      //     isNumeric: true,
      //     styles: {
      //       sizes: {
      //         width: '120px'
      //       }
      //     }
      //   }
      // }),
      // columnHelper.accessor('updatedAt', {
      //   header: t('services.table.updatedAt'),
      //   id: 'updatedAt',
      //   cell: ({ getValue }) => formatDateToHuman(getValue(), false),
      //   meta: {
      //     isNumeric: true,
      //     styles: {
      //       sizes: {
      //         width: '120px'
      //       }
      //     }
      //   }
      // }),
      columnHelper.accessor('id', {
        header: '',
        id: 'actions',
        cell: ({ row }) => (
          // <MainItemMenu
          //   data={row.original as FixMeLater}
          //   viewLink={PathsE.SHOW_ACTOR}
          //   editLink={PathsE.UPDATE_ACTOR}
          //   pathsParams={{
          //     serviceId,
          //     actorId: row.original.id?.toString()
          //   }}
          // />
          <Link
            path={PathsE.UPDATE_ACTOR}
            pathsParams={{ serviceId, actorId: row.original.id?.toString() }}
            >
            <IconButton
              mr="2"
              aria-label="Edit"
              borderRadius="10px"
              backgroundColor="transparent"
              icon={<MuiIcon name="edit" color={blue500} />}
            />
          </Link>

        ),
        meta: {
          styles: {
            sizes: {
              width: '44px'
            }
          }
        }
      }),
    ] as ColumnDef<ActorsElementT>[],
    [t, serviceId]
  );
};
